export const isFacebookApp = () => {
	if (typeof window === 'undefined') {
		return false;
	}

	const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
	return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1 || ua.indexOf('Instagram') > -1;
};

export function uploadFile(
	url: string,
	file: File,
	uploadProgressCallback: (progress: number) => void,
): Promise<void> {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();

		// listen for `load` event
		xhr.upload.onload = request => {
			resolve();
		};

		// listen for `error` event
		xhr.upload.onerror = () => {
			reject();
		};

		// listen for `abort` event
		xhr.upload.onabort = () => {
			reject();
		};

		xhr.upload.onprogress = progressEvent => {
			uploadProgressCallback((progressEvent.loaded / progressEvent.total) * 100);
		};

		// open and send request
		xhr.open('PUT', url);
		xhr.setRequestHeader('Content-Type', file.type);
		xhr.send(file);
	});
}
